// @ts-check

(() => {
  const OPEN_CLASS = 'is-open';
  const BODY_LOCK_CLASS = 'ps-nutrition-label-open';
  const CLOSE_DELAY_MS = 360;
  const PREV_OVERFLOW_KEY = 'psNutritionPrevOverflow';

  const lockScroll = () => {
    document.body.classList.add(BODY_LOCK_CLASS);
    document.body.dataset[PREV_OVERFLOW_KEY] = document.body.style.overflow || '';
    document.body.style.overflow = 'hidden';
  };

  const unlockScroll = () => {
    document.body.classList.remove(BODY_LOCK_CLASS);
    document.body.style.overflow = document.body.dataset[PREV_OVERFLOW_KEY] || '';
    delete document.body.dataset[PREV_OVERFLOW_KEY];
  };

  /** @param {string} modalId */
  const getModalById = (modalId) => document.getElementById(modalId);

  /** @param {HTMLElement | null} modal */
  const closeModal = (modal) => {
    if (!modal) return;

    const trigger = /** @type {HTMLButtonElement | null} */ (document.querySelector(`[data-ps-nutrition-open="${modal.id}"]`));
    modal.classList.remove(OPEN_CLASS);

    setTimeout(() => {
      modal.setAttribute('hidden', '');
    }, CLOSE_DELAY_MS);

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }

    unlockScroll();
  };

  /**
   * @param {HTMLElement | null} modal
   * @param {HTMLButtonElement | null} trigger
   */
  const openModal = (modal, trigger) => {
    if (!modal) return;

    modal.removeAttribute('hidden');
    requestAnimationFrame(() => {
      modal.classList.add(OPEN_CLASS);
    });

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    const panel = /** @type {HTMLElement | null} */ (modal.querySelector('.ps-nutrition-label__panel'));
    if (panel) {
      panel.scrollTop = 0;
      setTimeout(() => panel.focus(), 60);
    }

    lockScroll();
  };

  /** @param {HTMLElement | null} modal */
  const bindModal = (modal) => {
    if (!modal || modal.dataset.psNutritionBound === 'true') return;

    modal.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const closeElement = event.target.closest('[data-ps-nutrition-close]');
      if (!closeElement) return;

      event.preventDefault();
      closeModal(modal);
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeModal(modal);
    });

    modal.dataset.psNutritionBound = 'true';
  };

  /** @param {ParentNode | null} scope */
  const bindTriggers = (scope) => {
    const root = scope || document;

    root.querySelectorAll('[data-ps-nutrition-open]').forEach((triggerElement) => {
      const trigger = /** @type {HTMLButtonElement} */ (triggerElement);
      if (trigger.dataset.psNutritionBound === 'true') return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        const modalId = trigger.getAttribute('data-ps-nutrition-open');
        if (!modalId) return;
        const modal = getModalById(modalId);
        if (!modal) return;

        document.querySelectorAll('.ps-nutrition-label__modal').forEach((currentModalElement) => {
          const currentModal = /** @type {HTMLElement} */ (currentModalElement);
          if (currentModal !== modal && !currentModal.hasAttribute('hidden')) {
            closeModal(currentModal);
          }
        });

        bindModal(modal);
        openModal(modal, trigger);
      });

      trigger.dataset.psNutritionBound = 'true';
    });
  };

  /** @param {ParentNode | null} scope */
  const init = (scope) => {
    bindTriggers(scope);

    const root = scope || document;
    root.querySelectorAll('.ps-nutrition-label__modal').forEach((modalElement) => {
      bindModal(/** @type {HTMLElement} */ (modalElement));
    });
  };

  // Exposed so AJAX-driven product switches (mgo-variants.js) can re-bind the
  // trigger + modal after the drawer markup is swapped in for the new product.
  // The listeners below only fire on initial load and shopify:section:load,
  // neither of which runs on the variant switcher's section-render swap.
  /** @type {any} */ (window).psNutritionLabelInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const customEvent = /** @type {CustomEvent} */ (event);
    if (customEvent.target instanceof Element) {
      init(customEvent.target);
      return;
    }
    init(document);
  });
})();